var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center w-100 h-100",attrs:{"id":"rgbImgContainer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }